export default __webpack_public_path__ + "static/media/memories-no-2.4cab0d1a.ogg";